/**
 * i:
 * ------------------------------------------------------------------------------
 *
 *
 * @namespace i
 */

/**
 * Return a Shopify locale string directly from shopify/locales/*.json.
 * This function is added to the global `window.mint` object.
 * key:value pairs of text to replace
 * in the string, e.g. { label: 'New' } would replace `{{ label }}` in the
 * string.
 *
 * @example
 *  mint.Strings('general.accessibility.read_more')
 *  mint.Strings('general.accessibility.read_more', {
 *   replace: {
 *    colour: 'Red',
 *    label: 'New'
 *   }
 * })
 * https://shopify.dev/docs/themes/architecture/locales/storefront-locale-files#name-structure
 * @param {String} stringPath - Path to compiled string defined in `theme-strings.liquid`,
 * @param {Object} [data] - Data object.
 * @param {Object} [data.replace] - Replicates the Liquid replace functionality using key:value pairs. { colour: Red } would replace `{{ colour }}` in the string.
 * @returns {String}
 */
export function getString(stringPath, {
  replace = {},
} = {}) {
  let string = mint.localeStrings

  stringPath.split('.').forEach((part) => {
    string = string[part]
  })

  /**
   * Handle errors.
   */
  if (!string) {
    window.console.warn(`[Mint] No locale string found at 'mint.localeStrings.${stringPath}'.`)

    return mint.env.mode === 'development'
      ? `Error: '${stringPath}' does not exist in shopify/locales/*.json.`
      : 'No string found'
  }

  /**
   * Loop over all `replace` instances and perform replacement.
   */
  if (Object.keys(replace).length) {
    Object.keys(replace).forEach((key) => {
      string = string.replace(
        new RegExp(`{{ ${key} }}`, 'g'),
        replace[key],
      )
    })
  }

  return string
}